<template lang="pug">
    lairdnd-registration(
        :settings="settings"
        :translations="translations"
    )
</template>

<script>
export default {
    name: 'registration-page',

    metaInfo() { return {
        title: this.metaTitle,
        meta: [
            { name: 'description', content: this.metaDescription },
            { name: 'og:title', content: `${this.metaTitle} - Lair DND` },
            { name: 'og:description', content: this.metaDescription },
        ],
    }},

    data() { return {
        settings: {
            showNotice: false,
            login: {
                route: 'login-page',
            },
            form: {
                fields: {
                    username: {
                        attr: {
                            lazy: true,
                        },
                    },
                    email: {
                        show: true,
                    },
                    password: {
                        show: true,
                        attr: {
                            lazy: true,
                        },
                    },
                    first_name: {
                        show: false,
                        validations: false,
                    },
                    last_name: {
                        show: false,
                        validations: false,
                    },
                    terms: {
                        show: true,
                        urls: {
                            terms: {
                                url: '/terms-conditions',
                            },
                            privacy: {
                                url: '/privacy-policy',
                            },
                        },
                    },
                    subscribe: {
                        show: true,
                    },
                },
            },
            submitButtonTitle: 'Register',
            noSuccessScreen: false,
            submitOnEnter: true,
        },
        translations: {
            title: 'Let’s get started',
            login: {
                label: 'Already have an account?',
                link: 'Log In',
            },
            form: {
                fields: {
                    password: {
                        label: 'Password',
                    },
                    terms: {
                        urls: {
                            general: 'I agree to Platform\'s ',
                            terms: 'Terms & Conditions',
                            and: ' and ',
                            privacy: 'Privacy Policy',
                        },
                    }
                },
            },
        },
    }},

    computed: {
        metaTitle() {
            return 'Register'
        },
        metaDescription() {
            return 'Become a member and link up with groups of players to create fantastic gaming experiences'
        },
    },
}
</script>
